/**
 * Office permission for labor-item billable hours (#2706).
 * `work_orders.update` is not enough: Mekaanikko already holds it.
 */
export const EDIT_BILLABLE_HOURS_PERMISSION = 'work_orders.edit_billable_hours' as const;
